// extracted by mini-css-extract-plugin
export default {"app":"calendar_app__ekyIG","getEventDetails":"calendar_getEventDetails__pjKsD","dateTime":"calendar_dateTime__Yrgon"};